var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.overlay ? 'fill-height bg-overlay' : 'fill-height bg',style:(_vm.cssVars)})
}
var staticRenderFns = []

export { render, staticRenderFns }